var _rect, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForms1A3B(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 22,
    viewBox: "0 0 69 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 20.5,
    height: 20.5,
    rx: 10.25,
    fill: "white",
    stroke: "#9EB1D8",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4475 17V15.528H33.0875V5.65602H31.5195V17H38.4475Z",
    fill: "#252435"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4535 14.936C39.4535 16.152 40.4615 17.24 42.0295 17.24C43.4055 17.24 44.1735 16.504 44.5095 15.96C44.5095 16.52 44.5575 16.808 44.5895 17H46.0615C46.0295 16.808 45.9655 16.408 45.9655 15.736V11.88C45.9655 10.376 45.0695 9.06402 42.7655 9.06402C41.1015 9.06402 39.7735 10.088 39.6135 11.56L41.0535 11.896C41.1495 11 41.7415 10.344 42.7975 10.344C43.9655 10.344 44.4615 10.968 44.4615 11.72C44.4615 11.992 44.3335 12.232 43.8695 12.296L41.7895 12.6C40.4615 12.792 39.4535 13.56 39.4535 14.936ZM42.2375 15.976C41.4695 15.976 40.9895 15.432 40.9895 14.856C40.9895 14.168 41.4695 13.8 42.1095 13.704L44.4615 13.352V13.704C44.4615 15.384 43.4695 15.976 42.2375 15.976Z",
    fill: "#252435"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8285 17V15.88C50.3085 16.712 51.1885 17.208 52.3245 17.208C54.6125 17.208 55.9085 15.4 55.9085 13.112C55.9085 10.872 54.7085 9.08002 52.3725 9.08002C51.0925 9.08002 50.1965 9.70402 49.8285 10.392V5.41602H48.3405V17H49.8285ZM54.3725 13.112C54.3725 14.776 53.4765 15.864 52.1005 15.864C50.7725 15.864 49.8125 14.776 49.8125 13.112C49.8125 11.448 50.7725 10.408 52.1005 10.408C53.4925 10.408 54.3725 11.448 54.3725 13.112Z",
    fill: "#252435"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9285 12.36C58.9925 11.368 59.7605 10.392 61.0245 10.392C62.3845 10.392 63.1045 11.256 63.1365 12.36H58.9285ZM63.3605 14.36C63.0725 15.224 62.4485 15.912 61.2005 15.912C59.9045 15.912 58.9125 14.952 58.8805 13.576H64.6725C64.6885 13.48 64.7045 13.288 64.7045 13.096C64.7045 10.696 63.3765 9.06402 61.0085 9.06402C59.0725 9.06402 57.3285 10.712 57.3285 13.128C57.3285 15.736 59.1365 17.24 61.2005 17.24C62.9925 17.24 64.2245 16.168 64.6565 14.808L63.3605 14.36Z",
    fill: "#252435"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0945 17V5.41602H66.5905V17H68.0945Z",
    fill: "#252435"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForms1A3B);
export default __webpack_public_path__ + "static/media/forms1a3b.3e1a5bd02424cd1b35f144df0df7dc85.svg";
export { ForwardRef as ReactComponent };